import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { PostHogProvider } from 'posthog-js/react'

const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {posthogKey ? (
      <PostHogProvider
        apiKey={posthogKey}
        options={{
          api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || '/p',
          ui_host: import.meta.env.VITE_PUBLIC_POSTHOG_UI_HOST || 'https://us.posthog.com',
          defaults: '2025-05-24',
          capture_exceptions: true,
          debug: import.meta.env.MODE === 'development',
        }}
      >
        <App />
      </PostHogProvider>
    ) : (
      <App />
    )}
  </StrictMode>,
)
